import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Select from "react-select";
import "../../.csscode/ObservationScreen.css";
import { toast } from "sonner";
import SucessModal from "../successModal/SuccessModal";
import { getDropDownVal } from "../dropdownUtils";
import ObservationDetails from "./ObservationDetails";
import AuditeeHistory from "./AuditeeHistory";
import SuggestionActReferenceModal from "./Sug&actrefpopModalforSelect";
import ExportPrint from "./ExportPDFConfirmDialog";
import ExportToWordHTML from "./ExportWordConfirmDialog";
import CustomLoader from "../static/CustomLoader";

import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";

const pageStyles = `
.obs-page {
   width: 100%;
  min-height: 100vh;
  height: auto;
  display: flex;
  flex-direction: column;
  background: #f1f5f9;
  color: #0f172a;
  overflow-y: auto;
}
.obs-page *, .obs-page *::before, .obs-page *::after { box-sizing: border-box; }

/* ============================ HEADER ============================ */
.obs-header {
  position: sticky;
  top: 0;
  z-index: 1100;
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  padding: 10px 24px 14px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(15,23,42,.06);
}
.obs-header-select { flex: 1 1 320px; min-width: 0; max-width: 520px; }
.obs-header-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* ============================ BODY ============================ */
.obs-body {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 4px 4px 12px;
  flex: 0 0 auto;
}


/* ============================ BUTTONS ============================ */
.obs-btn {
  display: inline-flex; align-items: center; justify-content: center;
  gap: 8px; height: 42px; padding: 0 18px;
  border: 1px solid transparent; border-radius: 8px;
  font-size: 14px; font-weight: 600; line-height: 1;
  white-space: nowrap; cursor: pointer; user-select: none;
  transition: background-color .2s, box-shadow .2s, transform .1s, border-color .2s;
}
.obs-btn svg { font-size: 20px; }
.obs-btn:focus-visible { outline: 3px solid rgba(79,70,229,.35); outline-offset: 2px; }
.obs-btn:active:not(:disabled) { transform: translateY(1px); }
.obs-btn:disabled { opacity: .5; cursor: not-allowed; box-shadow: none; }

.obs-btn--success { background: #16a34a; color: #fff; box-shadow: 0 2px 6px rgba(22,163,74,.3); }
.obs-btn--success:hover:not(:disabled) { background: #15803d; }
.obs-btn--danger { background: #fff; color: #dc2626; border-color: #fca5a5; }
.obs-btn--danger:hover:not(:disabled) { background: #fef2f2; border-color: #dc2626; }

/* ============================ FIELDS ============================ */
.obs-label { display: block; margin: 0 0 6px; font-size: 13px; font-weight: 600; color: #334155; }
.obs-input, .obs-textarea {
  width: 100%; border: 1px solid #cbd5e1; border-radius: 8px;
  padding: 10px 12px; font-size: 14px; font-family: inherit;
  color: #0f172a; background: #fff; transition: border-color .2s, box-shadow .2s;
}
.obs-input { height: 42px; padding: 0 12px; }
.obs-textarea { resize: vertical; min-height: 80px; }
.obs-input:focus, .obs-textarea:focus { outline: none; border-color: #4f46e5; box-shadow: 0 0 0 3px rgba(79,70,229,.15); }
.obs-error { display: block; margin-top: 4px; font-size: 12px; color: #dc2626; }

/* ============================ REPORT TABLE ============================ */
.obs-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0;
  margin-bottom: 0;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
}
.obs-report-wrap { width: 100%; overflow-x: auto; border-radius: 12px; }
.obs-report-table { width: 100%; min-width: 640px; border-collapse: collapse; font-size: 14px; background: #fff; }
.obs-report-table td { border: 1px solid #cbd5e1; padding: 12px 14px; vertical-align: top; }
.obs-report-table .obs-section-row td {
  background: linear-gradient(90deg, #1e293b 0%, #334155 100%);
  color: #fff; font-weight: 700; font-size: 14px; letter-spacing: .2px;
  padding: 0; border: 1px solid #1e293b;
}
.obs-section-header { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 16px; }
.obs-section-title { display: inline-flex; align-items: center; gap: 0; }
.obs-section-toggle {
  display: inline-flex; align-items: center; justify-content: center;
  width: 30px; height: 30px;
  border: 1px solid rgba(255,255,255,.28); border-radius: 8px;
  background: rgba(255,255,255,.08); color: #fff; cursor: pointer;
  transition: background-color .18s, border-color .18s, transform .1s;
  flex: 0 0 auto;
}
.obs-section-toggle:hover { background: rgba(255,255,255,.22); border-color: rgba(255,255,255,.5); }
.obs-section-toggle:focus-visible { outline: 2px solid rgba(255,255,255,.65); outline-offset: 2px; }
.obs-section-toggle:active { transform: translateY(1px); }
.obs-section-toggle svg { font-size: 20px; }
.obs-report-table .obs-particulars { width: 26%; background: #f8fafc; font-weight: 600; color: #1e293b; font-size: 13.5px; vertical-align: top; }
.obs-report-table .obs-details { background: #fff; }
.obs-report-table .obs-fullrow { padding: 16px; background: #fff; border: 1px solid #cbd5e1; }

.obs-general-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; width: 100%; }
.obs-general-field { min-width: 0; }
.obs-general-label { display: block; margin: 0 0 6px; font-size: 12.5px; font-weight: 600; color: #334155; }

/* ============================ NESTED TABLE ============================ */
.obs-table-wrap { border: 1px solid #e2e8f0; border-radius: 10px; overflow-x: auto; }
.obs-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.obs-table th { background: #334155; color: #fff; font-weight: 600; font-size: 12px; text-align: left; padding: 8px 10px; white-space: nowrap; }
.obs-table td { padding: 8px 10px; border-top: 1px solid #e2e8f0; vertical-align: top; }
.obs-table tbody tr:hover { background: #f8fafc; }
.obs-table .obs-center { text-align: center; }
.obs-table input[type="checkbox"] { width: 18px; height: 18px; accent-color: #4f46e5; cursor: pointer; }
.obs-th-check { display: inline-flex; align-items: center; gap: 8px; cursor: pointer; }
.obs-order-input { width: 90px; height: 34px; padding: 0 8px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 13px; }
.obs-order-input:focus { outline: none; border-color: #4f46e5; box-shadow: 0 0 0 3px rgba(79,70,229,.15); }
.obs-nodata { padding: 16px; text-align: center; color: #64748b; border: 1px dashed #cbd5e1; border-radius: 10px; }

.obs-cell-stack { display: flex; flex-direction: column; gap: 8px; }

/* ============================ EMPTY / LOADING ============================ */
.obs-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; min-height: 55vh; padding: 32px; border: 2px dashed #cbd5e1; border-radius: 16px; background: #f8fafc; }
.obs-empty-icon { width: 96px; height: 96px; margin-bottom: 16px; display: flex; align-items: center; justify-content: center; border-radius: 50%; background: #e0e7ff; }
.obs-empty-icon svg { font-size: 52px; color: #4f46e5; }
.obs-empty h3 { margin: 0; font-size: 20px; font-weight: 600; color: #1e293b; }
.obs-empty p { margin: 6px 0 0; max-width: 380px; font-size: 14px; color: #64748b; }

.obs-loading-row { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; font-size: 14px; font-weight: 500; color: #475569; }
.obs-spinner { display: inline-block; width: 18px; height: 18px; border: 2.5px solid currentColor; border-right-color: transparent; border-radius: 50%; animation: obs-spin .7s linear infinite; }
.obs-spinner--lg { width: 24px; height: 24px; color: #4f46e5; }
.obs-skel-row { display: flex; gap: 16px; margin-bottom: 16px; }
.obs-skel { flex: 1; border-radius: 8px; margin-bottom: 16px; background: linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 50%, #e2e8f0 75%); background-size: 200% 100%; animation: obs-shimmer 1.4s ease-in-out infinite; }
.obs-skel-row .obs-skel { margin-bottom: 0; }
@keyframes obs-spin { to { transform: rotate(360deg); } }
@keyframes obs-shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }

/* ============================ HIDDEN EXPORT HOST ============================ */
.obs-offscreen { position: absolute; left: -9999px; top: 0; width: 1px; height: 1px; overflow: hidden; opacity: 0; pointer-events: none; }

/* ============================ FLOATING BUTTONS ============================ */
.obs-fab { display: inline-flex; align-items: center; justify-content: center; width: 46px; height: 46px; border: none; border-radius: 50%; color: #fff; cursor: pointer; box-shadow: 0 4px 12px rgba(15,23,42,.25); transition: transform .15s, box-shadow .2s, background-color .2s; }
.obs-fab:hover { transform: translateY(-2px); box-shadow: 0 6px 16px rgba(15,23,42,.3); }
.obs-fab:focus-visible { outline: 3px solid rgba(79,70,229,.35); outline-offset: 2px; }
.obs-fab--indigo { background: #4f46e5; }
.obs-fab--indigo:hover { background: #4338ca; }
.obs-fab--slate { background: #475569; }
.obs-fab--slate:hover { background: #334155; }
.obs-fab-stack { position: fixed; right: 24px; bottom: 30px; z-index: 9999; display: flex; flex-direction: column; gap: 10px; }
.obs-fab-suggest { position: fixed; top: 250px; right: 24px; z-index: 2002; }

/* ============================ RESPONSIVE ============================ */
@media (max-width: 900px) {
  .obs-header { padding: 10px 14px 12px; gap: 10px; align-items: stretch; }
  .obs-header-select { flex: 1 1 100%; max-width: 100%; }
  .obs-header-actions { margin-left: 0; width: 100%; justify-content: flex-end; gap: 8px; }
  .obs-body { padding: 16px 14px 96px; }
  .obs-report-table .obs-particulars { width: 32%; }
  .obs-general-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 600px) {
  .obs-header { padding: 10px 10px 10px; }
  .obs-header-actions { gap: 6px; justify-content: stretch; }
  .obs-body { padding: 12px 10px 96px; }
  .obs-report-table { font-size: 13px; min-width: 560px; }
  .obs-report-table td { padding: 10px 10px; }
  .obs-report-table .obs-particulars { width: 36%; font-size: 12.5px; }
  .obs-report-table .obs-fullrow { padding: 12px; }
  .obs-section-header { padding: 9px 12px; }
  .obs-section-toggle { width: 28px; height: 28px; }
  .obs-general-grid { grid-template-columns: 1fr; gap: 12px; }
  .obs-empty { padding: 24px 16px; min-height: 45vh; }
  .obs-empty-icon { width: 72px; height: 72px; margin-bottom: 12px; }
  .obs-empty-icon svg { font-size: 40px; }
  .obs-empty h3 { font-size: 17px; }
  .obs-empty p { font-size: 13px; }
  .obs-fab-stack { right: 14px; bottom: 20px; }
  .obs-fab-suggest { right: 14px; top: 200px; }
  .obs-fab { width: 42px; height: 42px; }
}
@media (max-width: 400px) {
  .obs-report-table { min-width: 520px; }
}
`;

const AuditObsUser = () => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const today = new Date().toISOString().split("T")[0];
  const userdetails = JSON.parse(localStorage.getItem("user"));
  const orgdetails = JSON.parse(localStorage.getItem("org"));
  const [usedCodeList, setUsedCodeList] = useState([]);
  const [scheduleList, setScheduleList] = useState([]);
  const [user, setUser] = useState("");
  const [scheduleid, setScheduleid] = useState("");
  const [userData, setUserData] = useState([{}]);
  const [selectedDatacode, setSelectedDatacode] = useState("");
  const [pendingScheduleId, setPendingScheduleId] = useState(null);
  const [id, setId] = useState("");
  const [code, setCode] = useState("");
  const [firstNote, setFirstNote] = useState("");
  const [lastNote, setLastNote] = useState("");
  const [observationdate, setObservationdate] = useState(today);
  const [details, setDetails] = useState([]);
  const [mode, setMode] = useState("U");
  const [auditeecode, setAuditeecode] = useState("");
  const [auddetails, setAuddetails] = useState([]);
  const [errors, setErrors] = useState({});
  const [chapterList, setChapterList] = useState([{}]);
  const [questionList, setQuestionList] = useState([{}]);
  const [divcodeList, setDivcodeList] = useState([{}]);
  const [annextureList, setAnnextureList] = useState([{}]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [emptypeOptions, setEmptypeOptions] = useState([]);
  const [empData, setEmpData] = useState([{}]);
  const [SuggandActList, setSuggandActList] = useState([{}]);
  const [acknowlgemts, setAcknowlgemts] = useState([]);
  const [executiveSummaries, setExecutiveSummaries] = useState([]);
  const [selectedSummary, setSelectedSummary] = useState({
    value: "",
    label: "",
    content: "",
  });
  const [categoryPriorty, setCategoryPriorty] = useState([]);
  const [selectedCategoryPriorty, setSelectedCategoryPriorty] = useState({
    value: "",
    label: "",
    content: "",
  });
  const [introductionContent, setIntroductionContent] = useState("");
  const [recommendationContent, setRecommendationContent] = useState("");
  const [conclusionContent, setConclusionContent] = useState("");
  const [referencesContent, setReferencesContent] = useState("");
  const [abbreviationContent, setAbbreviationContent] = useState("");
  const [auditcodeList, setAuditcodeList] = useState([{}]);
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [insploading, setInsploading] = useState(false);
  const [showRefModal, setShowRefModal] = useState(false);
  const [selectedAck, setSelectedAck] = useState({
    value: "",
    label: "",
    content: "",
  });

  const [basicDetailsExpanded, setBasicDetailsExpanded] = useState(false);
  const [observationExpanded, setObservationExpanded] = useState(true);

  const [showAIModal, setShowAIModal] = useState(false);
  const [documents, setDocuments] = useState([
    { id: "", fileName: "", fileType: "", selected: false, orderBy: "" },
  ]);

  const [scheduleLoading, setScheduleLoading] = useState(false);
  const [bodyLoading, setBodyLoading] = useState(false);
  const [docsLoading, setDocsLoading] = useState(false);

  const isBodyLoading = bodyLoading || docsLoading;

  const selectedDocuments = [...documents]
    .filter((doc) => doc.selected === true)
    .sort((a, b) => (Number(a.orderBy) || 0) - (Number(b.orderBy) || 0));

  const scrollContainerRef = useRef(null);
  const auditeeHistoryRef = useRef(null);
  const suggButtonRef = useRef(null);
  const exportRef = useRef();

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
  };

  const toggleSelectFile = (identifier) => {
    setDocuments((prev) =>
      prev.map((doc) => {
        const key = doc.id ? String(doc.id) : doc.fileName;
        if (!key) return doc;
        if (key === String(identifier))
          return { ...doc, selected: !doc.selected };
        return doc;
      }),
    );
  };

  const toggleSelectAllFiles = () => {
    setDocuments((prev) => {
      if (!prev || prev.length === 0) return prev;
      const allSelected = prev.every((d) => d.selected);
      return prev.map((d) => ({ ...d, selected: !allSelected }));
    });
  };

  const scrollToTop = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const scrollToBottom = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: scrollContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  const flattenGroupedDetails = (groupedData) => {
    const flatList = [];
    groupedData.forEach((group) => {
      const { chapter, chapterStatus, questions } = group;
      questions.forEach((q) => {
        flatList.push({
          ...q,
          chapter,
          chapterStatus: chapterStatus || q.chapterStatus || "",
        });
      });
    });
    return flatList;
  };

  const updateAuditeeFromSchedule = (
    scheduleCode,
    scheduleList,
    setAuditeecode,
  ) => {
    const selectedSchedule = scheduleList.find(
      (item) => item.value === scheduleCode,
    );
    if (selectedSchedule) setAuditeecode(selectedSchedule.auditee);
  };

  useEffect(() => {
    fetchUser();
    fetchSchedule();
    fetchAudeteeCode();
    fetchEmployee();
    fetchAnnexture();
    fetchDepartment();
    fetchQuestions();
    fetchChapter();
    fetchStatusOptions();
    fetchEmpOptions();
    fetchSuggandActRef();
    fetchData();
  }, []);

  useEffect(() => {
    if (pendingScheduleId) {
      fetchEmpDetailsByCode(pendingScheduleId);
      setPendingScheduleId(null);
    }
  }, [scheduleid, selectedDatacode, auditeecode, pendingScheduleId]);

  const fetchEmpDetailsByCode = async (selectedDatacode) => {
    setBodyLoading(true);
    if (selectedDatacode !== "") {
      try {
        const response = await axios.post(
          `${apiUrl}observation/scheduleid/${selectedDatacode}`,
          null,
          { headers },
        );
        if (response.data.cd === 1) {
          toast.info(response.data.description);
          setMode("A");
          setScheduleid(selectedDatacode);
          updateAuditeeFromSchedule(
            selectedDatacode,
            scheduleList,
            setAuditeecode,
          );
          if (userdetails) setUser(userdetails.empcode);
          setAuddetails([]);
          setDetails([]);
          setFirstNote("");
          setLastNote("");
          setSelectedAck({ value: "", label: "", content: "" });
          setSelectedSummary({ value: "", label: "", content: "" });
          setSelectedCategoryPriorty({ value: "", label: "", content: "" });
          setIntroductionContent("");
          setRecommendationContent("");
          setConclusionContent("");
          setReferencesContent("");
          setAbbreviationContent("");
          setObservationdate(today);
          setId(0);
          setCode(0);
        } else {
          setId(response.data.id);
          setCode(response.data.code);
          setUser(response.data.user);
          setScheduleid(response.data.scheduleid);
          updateAuditeeFromSchedule(
            response.data.scheduleid,
            scheduleList,
            setAuditeecode,
          );
          setObservationdate(response.data.observationdate);
          try {
            const parsedDetails = JSON.parse(response.data.details);
            const [empDetailArray, groupedDetails, notes, extraContent = {}] =
              parsedDetails;
            const extra = extraContent || {};
            setAuddetails(empDetailArray[0] || []);
            const flatDetails = flattenGroupedDetails(groupedDetails || []);
            const normalizedDetails = flatDetails.map((item) => {
              let remark = {};
              try {
                remark = JSON.parse(item.remark || "{}");
              } catch {
                remark = {};
              }
              return {
                ...item,
                aiObservation: item.aiObservation || remark.aiObservation || "",
              };
            });
            setDetails(normalizedDetails);
            setFirstNote(notes[0] || "");
            setLastNote(notes[1] || "");
            setSelectedAck({
              value: extra.acknowledgement?.value || "",
              label: extra.acknowledgement?.label || "",
              content: extra.acknowledgement?.content || "",
            });
            setSelectedSummary({
              value: extra.executiveSummary?.value || "",
              label: extra.executiveSummary?.label || "",
              content: extra.executiveSummary?.content || "",
            });
            setSelectedCategoryPriorty({
              value: extra.priorityCategory?.value || "",
              label: extra.priorityCategory?.label || "",
              content: extra.priorityCategory?.content || "",
            });
            setIntroductionContent(extra.introduction || "");
            setRecommendationContent(extra.recommendation || "");
            setConclusionContent(extra.conclusion || "");
            setReferencesContent(extra.references || "");
            setAbbreviationContent(extra.abbreviation || "");
            setMode("U");
          } catch (err) {
            console.error("Invalid JSON in details:", err);
            setDetails([]);
          }
        }
      } catch (error) {
        alert("Error fetching Observation details:", error);
        console.log(error);
      } finally {
        setBodyLoading(false);
      }
    } else {
      if (userdetails) setUser(userdetails.empcode);
      setBodyLoading(false);
    }
  };

  const fetchUser = async () => {
    try {
      const res = await axios.get(`${apiUrl}user`, { headers });
      setUsedCodeList(
        res.data.map((op) => ({ value: op.empcode, label: op.userid })),
      );
    } catch {
      setUsedCodeList([]);
    }
  };

  const fetchSchedule = async () => {
    setScheduleLoading(true);
    try {
      const res = await axios.post(
        `${apiUrl}schedule/openUserSchedule?user=${userdetails.empcode}`,
        null,
        { headers },
      );
      setScheduleList(
        res.data.map((op) => ({
          value: op.code,
          label: op.inspectiontitle,
          auditee: op.auditeecode,
          status: op.status,
        })),
      );
    } catch {
      setScheduleList([]);
    } finally {
      setScheduleLoading(false);
    }
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "observation", { headers })
        .then((response) => {
          if (response.data.cd === 1) setUserData([{}]);
          else setUserData(response.data);
        })
        .catch((error) => {
          console.log("error " + error);
          setUserData([{}]);
        });
    } catch {
      setUserData([{}]);
    } finally {
      setLoading(false);
    }
  };

  const fetchEmployee = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "employee", { headers })
        .then((response) => {
          if (response.data.cd === 1) setEmpData([{}]);
          else setEmpData(response.data);
        })
        .catch((error) => {
          console.log("error " + error);
          setEmpData([{}]);
        });
    } catch {
      setEmpData([{}]);
    } finally {
      setLoading(false);
    }
  };

  const fetchAudeteeCode = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "auditee", { headers })
        .then((response) => {
          setAuditcodeList(
            response.data.map((op) => ({ value: op.code, label: op.name })),
          );
        })
        .catch(() => setAuditcodeList([{}]));
    } catch {
      setAuditcodeList([{}]);
    } finally {
      setLoading(false);
    }
  };

  const fetchSuggandActRef = async () => {
    setLoading(true);
    try {
      const response = await axios.get(apiUrl + "suggandactref", { headers });
      const data = response.data || [];
      setSuggandActList(data);
      const filteredData = data.filter((item) => Number(item.type) === 4);
      setAcknowlgemts(
        filteredData.map((op) => ({
          value: op.code,
          label: op.name,
          content: op.content,
        })),
      );
      const filteredexcuative = data.filter((item) => Number(item.type) === 5);
      setExecutiveSummaries(
        filteredexcuative.map((op) => ({
          value: op.code,
          label: op.name,
          content: op.content,
        })),
      );
      const filteredCategories = data.filter((item) => Number(item.type) === 6);
      setCategoryPriorty(
        filteredCategories.map((op) => ({
          value: op.code,
          label: op.name,
          content: op.content,
        })),
      );
      setShowRefModal(false);
    } catch (error) {
      console.error("Error fetching sugg and act ref:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAnnexture = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "annexture", { headers })
        .then((response) => {
          setAnnextureList(
            response.data.map((op) => ({
              value: op.code,
              label: op.filename,
              path: op.path,
            })),
          );
        })
        .catch(() => setAnnextureList([{}]));
    } catch {
      setAnnextureList([{}]);
    } finally {
      setLoading(false);
    }
  };

  const fetchDepartment = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "division", { headers })
        .then((response) => {
          setDivcodeList(
            response.data.map((op) => ({ value: op.code, label: op.name })),
          );
        })
        .catch(() => setDivcodeList([{}]));
    } catch {
      setDivcodeList([{}]);
    } finally {
      setLoading(false);
    }
  };

  const fetchQuestions = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "question", { headers })
        .then((response) => {
          setQuestionList(
            response.data.map((op) => ({
              value: op.code,
              label: op.question,
              parent: op.parent,
              chaptercode: op.chaptercode,
            })),
          );
        })
        .catch(() => setQuestionList([{}]));
    } catch {
      setQuestionList([{}]);
    } finally {
      setLoading(false);
    }
  };

  const fetchChapter = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "chapter", { headers })
        .then((response) => {
          setChapterList(
            response.data.map((op) => ({
              value: op.code,
              label: op.chapter,
              label2: op.name,
            })),
          );
        })
        .catch(() => setChapterList([{}]));
    } catch {
      setChapterList([{}]);
    } finally {
      setLoading(false);
    }
  };

  const fetchStatusOptions = () => {
    try {
      const response = getDropDownVal("DEPS");
      setStatusOptions(
        response.map((op) => ({ value: op.code, label: op.value })),
      );
    } catch {
      console.log("error");
    }
  };

  const fetchEmpOptions = () => {
    try {
      const response = getDropDownVal("EMPTP");
      setEmptypeOptions(
        response.map((op) => ({ value: op.code, label: op.value })),
      );
    } catch {
      console.log("error");
    }
  };

  const handlescheduleclose = () => {
    setAuditeecode("");
    setSelectedDatacode("");
    setScheduleid("");
    setPendingScheduleId(null);
  };

  const validateFields = () => {
    let errors = {};
    if (!user) errors.user = "User is required...";
    if (!observationdate)
      errors.observationdate = "Observationdate Date is required...";
    if (!scheduleid) errors.scheduleid = "scheduleid is required...";
    if (auddetails.length < 1) errors.auddetails = "Please Add Basic Details.";
    return errors;
  };

  const handlesubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setLoading(true);
    const fieldErrors = validateFields();
    setErrors(fieldErrors);
    if (Object.keys(fieldErrors).length > 0) {
      toast.error("Please correct all required input fields.");
      setLoading(false);
      return;
    } else {
      const isValid = details.every((item) => {
        if (item.department) return item.startdate && item.enddate;
        return true;
      });
      if (!isValid) {
        alert("Please fill Start and End Dates for all selected departments.");
        setLoading(false);
        return;
      }
    }

    const transformDetailsToGrouped = (details) => {
      const groupedMap = {};
      details.forEach((item) => {
        const chapterKey = item.chapter;
        if (!groupedMap[chapterKey]) {
          groupedMap[chapterKey] = {
            chapter: chapterKey,
            chapterStatus: item.chapterStatus || "",
            questions: [],
          };
        }
        const { chapter, chapterStatus, ...questionData } = item;
        groupedMap[chapterKey].questions.push(questionData);
      });
      return Object.values(groupedMap);
    };

    const departmentTasksList = details
      .filter((item) => item.department)
      .map((item) => ({
        scheduleid: scheduleid,
        chapter: item.chapter,
        questionno: item.questionId,
        divcode: item.department,
        assigneduser: userdetails.empcode,
        assigneddate: today,
        startdate: item.startdate,
        enddate: item.enddate,
        status: parseInt(item.status) ? parseInt(item.status) : 1,
      }));

    const formData = {
      id,
      code,
      user,
      scheduleid,
      observationdate,
      details: JSON.stringify([
        [auddetails],
        transformDetailsToGrouped(details),
        [firstNote || "", lastNote || ""],
        {
          acknowledgement: {
            value: selectedAck?.value || "",
            label: selectedAck?.label || "",
            content: selectedAck?.content || "",
          },
          executiveSummary: {
            value: selectedSummary?.value || "",
            label: selectedSummary?.label || "",
            content: selectedSummary?.content || "",
          },
          priorityCategory: {
            value: selectedCategoryPriorty?.value || "",
            label: selectedCategoryPriorty?.label || "",
            content: selectedCategoryPriorty?.content || "",
          },
          introduction: introductionContent || "",
          recommendation: recommendationContent || "",
          conclusion: conclusionContent || "",
          references: referencesContent || "",
          abbreviation: abbreviationContent || "",
        },
      ]),
    };

    try {
      if (mode === "A") {
        setId(0);
        setCode(0);
        const response = await axios.post(apiUrl + "observation", formData, {
          headers,
        });
        await axios.post(apiUrl + "deptTasks", departmentTasksList, {
          headers,
        });
        if (response.data.cd === 1) {
          setLoading(false);
          setSucessMessage(response.data.description);
          setTitle("⚠️ Failed");
          setShowSucessModal(true);
        } else {
          setLoading(false);
          setSucessMessage(response.data.description);
          setTitle("✔️ Success");
          setShowSucessModal(true);
          window.location.reload();
        }
      } else {
        const response = await axios.put(apiUrl + "observation", formData, {
          headers,
        });
        await axios.post(apiUrl + "deptTasks", departmentTasksList, {
          headers,
        });
        if (response.data.cd === 1) {
          setLoading(false);
          setSucessMessage(response.data.description);
          setTitle("⚠️ Failed");
          setShowSucessModal(true);
        } else {
          setLoading(false);
          setSucessMessage(response.data.description);
          setTitle("✔️ Success");
          setShowSucessModal(true);
          window.location.reload();
        }
      }
    } catch (error) {
      alert("Some issue. Please check with Administrator..!", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const toggleBasicDetails = () => {
    if (basicDetailsExpanded) {
      setBasicDetailsExpanded(false);
      setInsploading(false);
      return;
    }
    if (!auditeecode) {
      toast.error(
        "Please select Schedule or Factory details in schedule is empty.",
      );
      return;
    }
    setBasicDetailsExpanded(true);
    setInsploading(true);
    setTimeout(() => {
      auditeeHistoryRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 300);
  };

  const handleClose1stInspection = () => {
    setInsploading(false);
    setBasicDetailsExpanded(false);
    setAuditeecode(auditeecode ? auditeecode : "");
  };

  const fetchExistingDocuments = async (code) => {
    setDocsLoading(true);
    try {
      const res = await axios.get(`${apiUrl}auditeedoc/${code}`, { headers });
      if (res.data.cd === 1) {
        toast.error(res.data.description || "No documents found");
        return;
      }
      const rows = res.data || [];
      const mappedDocs = rows.map((item) => ({
        id: item.id,
        fileName: item.name,
        fileType: item.type,
        selected: false,
        orderBy: "",
      }));
      setDocuments(
        mappedDocs.length > 0
          ? mappedDocs
          : [
              {
                id: "",
                fileName: "",
                fileType: "",
                selected: false,
                orderBy: "",
              },
            ],
      );
    } catch (err) {
      toast.error("Failed to load existing documents");
    } finally {
      setDocsLoading(false);
    }
  };

  const handleUserChange = (selectedOption) =>
    setUser(selectedOption ? selectedOption.value : "");

  const handlescheduleChange = async (selectedOption) => {
    if (selectedOption === null) {
      setAuditeecode("");
      setSelectedDatacode("");
      setScheduleid("");
      setPendingScheduleId(null);
      return;
    }
    if (selectedOption.status === 4) {
      toast.info(
        "This schedule has started its inspection througn mobile app. You cannot access here.",
      );
      setAuditeecode("");
      setSelectedDatacode("");
      setScheduleid("");
      setPendingScheduleId(null);
      return;
    }
    const selectedScheduleId = selectedOption ? selectedOption.value : "";
    const selectedAudetee = selectedOption ? selectedOption.auditee : "";
    setBodyLoading(true);
    setAuditeecode(selectedAudetee);
    setSelectedDatacode(selectedScheduleId);
    setScheduleid(selectedScheduleId);
    setPendingScheduleId(selectedScheduleId);
    await fetchExistingDocuments(selectedAudetee);
  };

  const customStyles = {
    placeholder: (p) => ({ ...p, fontWeight: "normal", color: "#94a3b8" }),
    control: (p, state) => ({
      ...p,
      fontWeight: "normal",
      minHeight: 42,
      borderRadius: 8,
      borderColor: state.isFocused ? "#4f46e5" : "#cbd5e1",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(79,70,229,.15)" : "none",
      "&:hover": { borderColor: state.isFocused ? "#4f46e5" : "#94a3b8" },
    }),
    menuPortal: (p) => ({ ...p, zIndex: 99999 }),
  };

  const emptyLibraryValue = { value: "", label: "", content: "" };

  const librarySections = [
    {
      title: "Acknowledgement",
      options: acknowlgemts,
      state: selectedAck,
      setState: setSelectedAck,
      selectPlaceholder: "Select Acknowledgement",
      contentPlaceholder: "Acknowledgement Content",
    },
    {
      title: "Executive Summary",
      options: executiveSummaries,
      state: selectedSummary,
      setState: setSelectedSummary,
      selectPlaceholder: "Select Executive Summary",
      contentPlaceholder: "Executive Summary Content",
    },
    {
      title: "Categories to Risk on base of Priority",
      options: categoryPriorty,
      state: selectedCategoryPriorty,
      setState: setSelectedCategoryPriorty,
      selectPlaceholder: "Select Categories",
      contentPlaceholder: "Categories Content",
    },
  ];

  const pasteFromClipboard = async (setValue) => {
    try {
      const text = await navigator.clipboard.readText();
      setValue(text);
    } catch (err) {
      console.error("Failed to paste from clipboard:", err);
    }
  };

  const noteSections = [
    {
      title: "Introduction",
      value: introductionContent,
      setValue: setIntroductionContent,
      placeholder: "Enter introduction...",
    },
    {
      title: "First Note",
      value: firstNote,
      setValue: setFirstNote,
      placeholder: "Enter First Note...",
      paste: true,
    },
    {
      title: "Recommendation",
      value: recommendationContent,
      setValue: setRecommendationContent,
      placeholder: "Enter Recommendation...",
    },
    {
      title: "Conclusion",
      value: conclusionContent,
      setValue: setConclusionContent,
      placeholder: "Enter Conclusion...",
    },
    {
      title: "References",
      value: referencesContent,
      setValue: setReferencesContent,
      placeholder: "Enter References...",
    },
    {
      title: "Abbreviation",
      value: abbreviationContent,
      setValue: setAbbreviationContent,
      placeholder: "Enter Abbreviation...",
    },
  ];

  const closingNote = {
    title: "Closing Note",
    value: lastNote,
    setValue: setLastNote,
    placeholder: "Enter closing note...",
    paste: true,
  };

  const noSchedule = !scheduleid;

  return (
    <>
      <style>{pageStyles}</style>
      <SucessModal
        show={ShowSucessModal}
        onClose={handleCloseSucessModal}
        headerText={titile}
        message={SucessMessage}
      />

      <div className="obs-page" ref={scrollContainerRef}>
        {/* ============== HEADER ============== */}
        <div className="obs-header">
          <div className="obs-header-select">
            <label className="obs-label">Select Schedule</label>
            <Select
              isClearable
              isLoading={scheduleLoading}
              isDisabled={scheduleLoading || isBodyLoading}
              value={
                scheduleList.find((opt) => opt.value === scheduleid) || null
              }
              onChange={handlescheduleChange}
              options={scheduleList}
              styles={customStyles}
              menuPortalTarget={document.body}
              placeholder={
                scheduleLoading ? "Loading schedules..." : "Select Schedule"
              }
              loadingMessage={() => "Loading schedules..."}
              noOptionsMessage={() => "No open schedules available"}
            />
          </div>

          <div className="obs-header-actions">
            {/* Export components render their own buttons (with their own styles) */}
            <ExportPrint
              ref={exportRef}
              orgdetails={orgdetails}
              auddetails={auddetails}
              details={details}
              firstNote={firstNote}
              lastNote={lastNote}
              chapterList={chapterList}
              divcodeList={divcodeList}
              annextureList={annextureList}
              statusOptions={statusOptions}
              emptypeOptions={emptypeOptions}
              scheduleid={scheduleid}
              observationdate={observationdate}
              user={user}
              empData={empData}
              ackContent={selectedAck.content}
              exSummaryContent={selectedSummary.content}
              introductionContent={introductionContent}
              PriorityContent={selectedCategoryPriorty.content}
              recommendation={recommendationContent}
              conclusion={conclusionContent}
              references={referencesContent}
              abbreviation={abbreviationContent}
              documents={selectedDocuments}
              auditeeCode={auditeecode}
              noSchedule={noSchedule}
              isBodyLoading={isBodyLoading}
              loading={loading}
              mode="A"
            />
            <ExportToWordHTML
              orgdetails={orgdetails}
              auddetails={auddetails}
              details={details}
              firstNote={firstNote}
              lastNote={lastNote}
              chapterList={chapterList}
              divcodeList={divcodeList}
              annextureList={annextureList}
              statusOptions={statusOptions}
              emptypeOptions={emptypeOptions}
              scheduleid={scheduleid}
              observationdate={observationdate}
              user={user}
              empData={empData}
              ackContent={selectedAck.content}
              exSummaryContent={selectedSummary.content}
              introductionContent={introductionContent}
              PriorityContent={selectedCategoryPriorty.content}
              recommendation={recommendationContent}
              conclusion={conclusionContent}
              references={referencesContent}
              abbreviation={abbreviationContent}
              documents={selectedDocuments}
              auditeeCode={auditeecode}
              noSchedule={noSchedule}
              isBodyLoading={isBodyLoading}
              loading={loading}
              mode="A"
            />

            <button
              type="button"
              className="obs-btn obs-btn--success"
              disabled={noSchedule || loading}
              onClick={handlesubmit}
              title="Save"
            >
              {loading ? (
                <span className="obs-spinner" />
              ) : (
                <SaveOutlinedIcon />
              )}
              {loading ? "Saving..." : "Save"}
            </button>

            <button
              type="button"
              className="obs-btn obs-btn--danger"
              disabled={noSchedule || isBodyLoading}
              onClick={handlescheduleclose}
              title="Close"
            >
              <CloseRoundedIcon />
              Close
            </button>
          </div>
        </div>

        <div className="obs-body">
          {!scheduleid && !isBodyLoading && (
            <div className="obs-empty">
              <div className="obs-empty-icon">
                <EventNoteOutlinedIcon />
              </div>
              <h3>No Schedule Selected</h3>
              <p>
                Select a schedule from the dropdown above to view or add
                observation details.
              </p>
            </div>
          )}

          {isBodyLoading && (
            <div>
              <div className="obs-loading-row">
                <span className="obs-spinner obs-spinner--lg" />
                Loading observation details...
              </div>
              <div className="obs-skel-row">
                <div className="obs-skel" style={{ height: 56 }} />
                <div className="obs-skel" style={{ height: 56 }} />
                <div className="obs-skel" style={{ height: 56 }} />
              </div>
              <div className="obs-skel" style={{ height: 180 }} />
              <div className="obs-skel" style={{ height: 90 }} />
              <div className="obs-skel" style={{ height: 90 }} />
              <div className="obs-skel" style={{ height: 140 }} />
            </div>
          )}

          {scheduleid && !isBodyLoading && (
            <>
              <div className="obs-card" style={{ padding: 0 }}>
                <div className="obs-report-wrap">
                  <table className="obs-report-table">
                    <tbody>
                      {/* ========= SECTION 1: GENERAL INFORMATION ========= */}
                      <tr className="obs-section-row">
                        <td colSpan={2}>
                          <div className="obs-section-header">
                            <span className="obs-section-title">
                              General Information
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} className="obs-fullrow">
                          <div className="obs-general-grid">
                            <div className="obs-general-field">
                              <label className="obs-general-label">
                                Auditeer / Inspector
                              </label>
                              <Select
                                name="user"
                                isClearable
                                value={
                                  user
                                    ? usedCodeList.find(
                                        (o) => o.value === user,
                                      ) || null
                                    : null
                                }
                                onChange={handleUserChange}
                                placeholder="Select Employee"
                                options={usedCodeList}
                                styles={customStyles}
                                menuPortalTarget={document.body}
                                classNamePrefix="select"
                              />
                              {errors.user && (
                                <span className="obs-error">{errors.user}</span>
                              )}
                            </div>
                            <div className="obs-general-field">
                              <label className="obs-general-label">
                                Schedule
                              </label>
                              <Select
                                name="schedule"
                                isDisabled
                                value={
                                  scheduleid
                                    ? scheduleList.find(
                                        (o) => o.value === scheduleid,
                                      ) || null
                                    : null
                                }
                                placeholder="Select Schedule"
                                options={scheduleList}
                                styles={customStyles}
                                menuPortalTarget={document.body}
                                classNamePrefix="select"
                              />
                              {errors.scheduleid && (
                                <span className="obs-error">
                                  {errors.scheduleid}
                                </span>
                              )}
                            </div>
                            <div className="obs-general-field">
                              <label className="obs-general-label">
                                Observation Date
                              </label>
                              <input
                                type="date"
                                required
                                title="Observation Date"
                                className="obs-input"
                                value={observationdate}
                                onChange={(e) =>
                                  setObservationdate(e.target.value)
                                }
                              />
                              {errors.observationdate && (
                                <span className="obs-error">
                                  {errors.observationdate}
                                </span>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>

                      {/* ========= SECTION 2: LIBRARY CONTENT ========= */}
                      <tr className="obs-section-row">
                        <td colSpan={2}>
                          <div className="obs-section-header">
                            <span className="obs-section-title">
                              Library Content
                            </span>
                          </div>
                        </td>
                      </tr>
                      {librarySections.map((s) => (
                        <tr key={s.title}>
                          <td className="obs-particulars">{s.title}</td>
                          <td className="obs-details">
                            <div className="obs-cell-stack">
                              <Select
                                isClearable
                                value={
                                  s.options.find(
                                    (o) => o.value === s.state.value,
                                  ) || null
                                }
                                onChange={(sel) =>
                                  s.setState(
                                    sel
                                      ? {
                                          value: sel.value,
                                          label: sel.label,
                                          content: sel.content,
                                        }
                                      : emptyLibraryValue,
                                  )
                                }
                                options={s.options}
                                placeholder={s.selectPlaceholder}
                                styles={customStyles}
                                menuPortalTarget={document.body}
                              />
                              <textarea
                                className="obs-textarea"
                                rows={4}
                                value={s.state.content}
                                placeholder={s.contentPlaceholder}
                                onChange={(e) =>
                                  s.setState((prev) => ({
                                    ...prev,
                                    content: e.target.value,
                                  }))
                                }
                              />
                            </div>
                          </td>
                        </tr>
                      ))}

                      {/* ========= SECTION 3: NOTES ========= */}
                      <tr className="obs-section-row">
                        <td colSpan={2}>
                          <div className="obs-section-header">
                            <span className="obs-section-title">
                              Notes &amp; Narrative
                            </span>
                          </div>
                        </td>
                      </tr>
                      {noteSections.map((n) => (
                        <tr key={n.title}>
                          <td className="obs-particulars">{n.title}</td>
                          <td className="obs-details">
                            <textarea
                              className="obs-textarea"
                              rows={3}
                              value={n.value}
                              placeholder={n.placeholder}
                              onDoubleClick={
                                n.paste
                                  ? () => pasteFromClipboard(n.setValue)
                                  : undefined
                              }
                              onChange={(e) => n.setValue(e.target.value)}
                            />
                          </td>
                        </tr>
                      ))}

                      {/* ========= SECTION 4: CLOSING NOTE ========= */}
                      <tr className="obs-section-row">
                        <td colSpan={2}>
                          <div className="obs-section-header">
                            <span className="obs-section-title">
                              Closing Note
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="obs-particulars">{closingNote.title}</td>
                        <td className="obs-details">
                          <textarea
                            className="obs-textarea"
                            rows={3}
                            value={closingNote.value}
                            placeholder={closingNote.placeholder}
                            onDoubleClick={
                              closingNote.paste
                                ? () => pasteFromClipboard(closingNote.setValue)
                                : undefined
                            }
                            onChange={(e) =>
                              closingNote.setValue(e.target.value)
                            }
                          />
                        </td>
                      </tr>

                      {/* ========= SECTION 5: EXISTING DOCUMENTS ========= */}
                      <tr className="obs-section-row">
                        <td colSpan={2}>
                          <div className="obs-section-header">
                            <span className="obs-section-title">
                              Existing Documents
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} className="obs-fullrow">
                          {!documents || documents.length === 0 ? (
                            <div className="obs-nodata">
                              No documents found.
                            </div>
                          ) : (
                            <div className="obs-table-wrap">
                              <table className="obs-table">
                                <thead>
                                  <tr>
                                    <th style={{ width: "45%" }}>
                                      Document Name
                                    </th>
                                    <th style={{ width: "20%" }}>File Type</th>
                                    <th style={{ width: "20%" }}>Order By</th>
                                    <th
                                      className="obs-center"
                                      style={{ width: "15%" }}
                                    >
                                      <label className="obs-th-check">
                                        <input
                                          type="checkbox"
                                          checked={
                                            documents.length > 0 &&
                                            documents.every(
                                              (d) => d.selected === true,
                                            )
                                          }
                                          onChange={toggleSelectAllFiles}
                                        />
                                        Select All
                                      </label>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {documents.map((doc, idx) => {
                                    const key = doc.id
                                      ? String(doc.id)
                                      : `doc-${idx}`;
                                    return (
                                      <tr key={key}>
                                        <td>{doc.fileName || "-"}</td>
                                        <td>{doc.fileType || "-"}</td>
                                        <td>
                                          <input
                                            type="number"
                                            className="obs-order-input"
                                            value={doc.orderBy || ""}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              setDocuments((prev) =>
                                                prev.map((d, i) =>
                                                  i === idx
                                                    ? { ...d, orderBy: value }
                                                    : d,
                                                ),
                                              );
                                            }}
                                          />
                                        </td>
                                        <td className="obs-center">
                                          <input
                                            type="checkbox"
                                            checked={!!doc.selected}
                                            onChange={() =>
                                              toggleSelectFile(
                                                doc.id
                                                  ? String(doc.id)
                                                  : doc.fileName,
                                              )
                                            }
                                          />
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </td>
                      </tr>

                      {/* ========= SECTION 6: BASIC DETAILS ========= */}
                      <tr className="obs-section-row">
                        <td colSpan={2}>
                          <div className="obs-section-header">
                            <span className="obs-section-title">
                              Basic Details
                            </span>
                            <button
                              type="button"
                              className="obs-section-toggle"
                              onClick={toggleBasicDetails}
                              title={
                                basicDetailsExpanded ? "Collapse" : "Expand"
                              }
                              aria-expanded={basicDetailsExpanded}
                            >
                              {basicDetailsExpanded ? (
                                <ExpandLessRoundedIcon />
                              ) : (
                                <ExpandMoreRoundedIcon />
                              )}
                            </button>
                          </div>
                        </td>
                      </tr>
                      {basicDetailsExpanded && (
                        <tr>
                          <td
                            colSpan={2}
                            className="obs-fullrow"
                            ref={auditeeHistoryRef}
                          >
                            <AuditeeHistory
                              selectedId={auditeecode}
                              mode="U"
                              onHide={handleClose1stInspection}
                              divData={divcodeList}
                              setAuddetails={setAuddetails}
                              auddetails={auddetails}
                              usedCodeList={usedCodeList}
                            />
                            {errors.auddetails && (
                              <span className="obs-error">
                                {errors.auddetails}
                              </span>
                            )}
                          </td>
                        </tr>
                      )}

                      {/* ========= SECTION 7: OBSERVATION DETAILS ========= */}
                      <tr className="obs-section-row">
                        <td colSpan={2}>
                          <div className="obs-section-header">
                            <span className="obs-section-title">
                              Observation Details
                            </span>
                            <button
                              type="button"
                              className="obs-section-toggle"
                              onClick={() => setObservationExpanded((v) => !v)}
                              title={
                                observationExpanded ? "Collapse" : "Expand"
                              }
                              aria-expanded={observationExpanded}
                            >
                              {observationExpanded ? (
                                <ExpandLessRoundedIcon />
                              ) : (
                                <ExpandMoreRoundedIcon />
                              )}
                            </button>
                          </div>
                        </td>
                      </tr>
                      {observationExpanded && (
                        <tr>
                          <td colSpan={2} className="obs-fullrow">
                            <ObservationDetails
                              selectedDatacode={selectedDatacode}
                              chapterList={chapterList}
                              questionList={questionList}
                              divcodeList={divcodeList}
                              statusOptions={statusOptions}
                              annextureList={annextureList}
                              details={details}
                              setDetails={setDetails}
                              handlesubmit={handlesubmit}
                              mode={mode}
                              showObsAIModal={showAIModal}
                              setShowObsAIModal={setShowAIModal}
                            />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {showRefModal && (
                <SuggestionActReferenceModal
                  open={showRefModal}
                  onClose={() => setShowRefModal(false)}
                  data={SuggandActList}
                />
              )}

              {loading && <CustomLoader />}
            </>
          )}
        </div>

        {scheduleid && !isBodyLoading && !showAIModal && (
          <>
            <div className="obs-fab-suggest">
              <button
                type="button"
                className="obs-fab obs-fab--indigo"
                title="Suggestions / Act References"
                ref={suggButtonRef}
                onClick={() => setShowRefModal(!showRefModal)}
              >
                <TipsAndUpdatesIcon />
              </button>
            </div>
            <div className="obs-fab-stack">
              <button
                type="button"
                className="obs-fab obs-fab--slate"
                title="Go to Top"
                onClick={scrollToTop}
              >
                <KeyboardArrowUpRoundedIcon />
              </button>
              <button
                type="button"
                className="obs-fab obs-fab--slate"
                title="Go to Bottom"
                onClick={scrollToBottom}
              >
                <KeyboardArrowDownRoundedIcon />
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AuditObsUser;
